import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { HappyTaskLoadingLogo } from '@/src/renderer/components/icons/HappyTaskLoadingLogo'
import './RedirectingToApp.scss'

/**
 * RedirectingToApp Component
 *
 * Displays a loading state when redirecting from web browser to the Electron app.
 * Shows the HappyTask logo and a message indicating the redirect is in progress.
 *
 * While mounted, marks `<body>` with `redirecting-to-app-active` so the
 * global `<Titlebar />` (rendered above this subtree at WindowFrame level)
 * can hide itself via CSS — the empty title-bar bar would otherwise paint
 * above the redirect content on `https://app.happytask.app/?source=electron`.
 *
 * Used on the web version when a password reset link is clicked.
 *
 * @example
 * ```tsx
 * <RedirectingToApp />
 * ```
 */
export function RedirectingToApp() {
  const { t } = useTranslation()

  useEffect(() => {
    document.body.classList.add('redirecting-to-app-active')
    return () => {
      document.body.classList.remove('redirecting-to-app-active')
    }
  }, [])

  return (
    <div className="redirecting-to-app">
      <div className="redirecting-to-app__content">
        <HappyTaskLoadingLogo />
        <p className="redirecting-to-app__message">
          {t('auth.redirecting.message')}
        </p>
      </div>
    </div>
  )
}
